/* Bundle add-on cart: auto-add custom.bundle_addon_product, sync qty/remove in cart */
(function () {
  'use strict';

  var PROP_ID = '_bundle_id';
  var PROP_ROLE = '_bundle_role';
  var PROP_ADDON_VARIANT = '_bundle_addon_variant_id';
  var PROP_MAIN_VARIANT = '_bundle_main_variant_id';
  var ROLE_MAIN = 'main';
  var ROLE_ADDON = 'addon';
  var STORAGE_KEY = 'mtBundlePairs';

  var originalFetch = window.fetch;

  function normalizeProps(props) {
    if (!props) return {};
    if (Array.isArray(props)) {
      var out = {};
      props.forEach(function (p) {
        out[p.name] = p.value;
      });
      return out;
    }
    return props;
  }

  function readPairStore() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writePairStore(store) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) {}
  }

  function persistPair(mainVariantId, addonVariantId, bundleId) {
    if (!mainVariantId || !addonVariantId) return;
    var store = readPairStore();
    var mainKey = String(mainVariantId);
    var addonKey = String(addonVariantId);
    store[mainKey] = { addonVariantId: addonKey, bundleId: bundleId || '' };
    store[addonKey] = { mainVariantId: mainKey, bundleId: bundleId || '' };
    writePairStore(store);
  }

  function collectBundleMap() {
    var map = window.__mtBundleMap || {};
    document.querySelectorAll('[data-mt-bundle-map]').forEach(function (el) {
      try {
        var data = JSON.parse(el.textContent);
        if (data && data.variants) {
          Object.keys(data.variants).forEach(function (k) {
            map[k] = data.variants[k];
          });
        }
      } catch (e) {}
    });
    window.__mtBundleMap = map;
    return map;
  }

  function buildBundleMapFromCart(cart) {
    collectBundleMap();
    if (!cart || !cart.items) return window.__mtBundleMap;

    cart.items.forEach(function (item) {
      var props = normalizeProps(item.properties);
      var mainVariantId = String(item.id);
      var addonVariantId = props[PROP_ADDON_VARIANT];
      var linkedMainVariantId = props[PROP_MAIN_VARIANT];

      if (addonVariantId) {
        window.__mtBundleMap[mainVariantId] = { addonVariantId: String(addonVariantId) };
        persistPair(mainVariantId, addonVariantId, props[PROP_ID]);
      }

      if (linkedMainVariantId) {
        window.__mtBundleMap[String(linkedMainVariantId)] = { addonVariantId: mainVariantId };
        persistPair(linkedMainVariantId, mainVariantId, props[PROP_ID]);
      }
    });

    return window.__mtBundleMap;
  }

  function getAddonVariantId(mainVariantId, cart) {
    var key = String(mainVariantId);
    if (!key) return null;

    if (cart && cart.items) {
      var fromCart = null;
      cart.items.some(function (item) {
        if (String(item.id) !== key) return false;
        var props = normalizeProps(item.properties);
        if (props[PROP_ADDON_VARIANT]) {
          fromCart = String(props[PROP_ADDON_VARIANT]);
          return true;
        }
        return false;
      });
      if (fromCart) return fromCart;
    }

    collectBundleMap();
    var entry = window.__mtBundleMap && window.__mtBundleMap[key];
    if (entry && entry.addonVariantId) return String(entry.addonVariantId);

    var store = readPairStore();
    if (store[key] && store[key].addonVariantId) return String(store[key].addonVariantId);

    var btn = document.querySelector(
      '[data-variant-id="' + key + '"][data-bundle-addon-variant]'
    );
    if (btn) return btn.getAttribute('data-bundle-addon-variant');
    return null;
  }

  function createBundleId() {
    return 'b_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 9);
  }

  function findExistingBundleId(cart, mainVariantId, addonVariantId) {
    if (!cart || !cart.items) return null;
    mainVariantId = String(mainVariantId);
    addonVariantId = String(addonVariantId);
    var found = null;

    cart.items.forEach(function (item) {
      if (found) return;
      if (String(item.id) !== mainVariantId) return;
      var props = normalizeProps(item.properties);
      if (props[PROP_ROLE] !== ROLE_MAIN) return;
      if (String(props[PROP_ADDON_VARIANT] || '') !== addonVariantId) return;
      if (props[PROP_ID]) found = props[PROP_ID];
    });

    return found;
  }

  function resolveBundleId(cart, mainVariantId, addonVariantId) {
    var existing = findExistingBundleId(cart, mainVariantId, addonVariantId);
    if (existing) return existing;
    return createBundleId();
  }

  function isAlreadyExpanded(bodyObj) {
    function hasBundleRole(item) {
      if (!item) return false;
      var props = normalizeProps(item.properties);
      return props[PROP_ROLE] === ROLE_MAIN || props[PROP_ROLE] === ROLE_ADDON;
    }

    if (bodyObj.items && Array.isArray(bodyObj.items)) {
      return bodyObj.items.some(hasBundleRole);
    }
    if (bodyObj.id != null) return hasBundleRole(bodyObj);
    return false;
  }

  function findBundleMain(cart, bundleId, excludeKey) {
    if (!bundleId || !cart || !cart.items) return null;
    return cart.items.find(function (i) {
      if (excludeKey && i.key === excludeKey) return false;
      var ip = normalizeProps(i.properties);
      if (ip[PROP_ROLE] === ROLE_MAIN && ip[PROP_ID] === bundleId) return true;
      if (!ip[PROP_ROLE] && ip[PROP_ID] === bundleId) return true;
      return false;
    });
  }

  function getDomLineEl(lineKey) {
    if (!lineKey) return null;
    var nodes = document.querySelectorAll('[data-key]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-key') === lineKey) return nodes[i];
    }
    return null;
  }

  function isAddonLine(cart, lineKey) {
    var el = getDomLineEl(lineKey);
    if (el && el.hasAttribute('data-bundle-addon')) return true;
    if (!cart || !cart.items) return false;
    var item = cart.items.find(function (i) { return i.key === lineKey; });
    if (!item) return false;
    var props = normalizeProps(item.properties);
    return props[PROP_ROLE] === ROLE_ADDON || !!props[PROP_MAIN_VARIANT];
  }

  function getLinkedAddonKeysFromDom(mainLineKey) {
    var el = getDomLineEl(mainLineKey);
    if (!el) return [];
    var raw = el.getAttribute('data-bundle-addon-keys');
    if (!raw) return [];
    return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function findLinkedAddons(cart, targetItem) {
    if (!cart || !cart.items || !targetItem) return [];

    buildBundleMapFromCart(cart);

    var props = normalizeProps(targetItem.properties);
    if (props[PROP_ROLE] === ROLE_ADDON) return [];

    var linked = [];
    var bundleId = props[PROP_ID];
    var targetKey = targetItem.key;

    function pushUnique(item) {
      if (!item || !item.key || item.key === targetKey) return;
      if (linked.some(function (entry) { return entry.key === item.key; })) return;
      linked.push(item);
    }

    if (bundleId) {
      cart.items.forEach(function (i) {
        var ip = normalizeProps(i.properties);
        if (ip[PROP_ID] === bundleId && i.key !== targetKey) {
          if (ip[PROP_ROLE] === ROLE_ADDON || ip[PROP_MAIN_VARIANT]) pushUnique(i);
        }
      });
    }

    if (props[PROP_ADDON_VARIANT]) {
      cart.items.forEach(function (i) {
        if (String(i.id) === String(props[PROP_ADDON_VARIANT])) pushUnique(i);
      });
    }

    var addonVariantId = getAddonVariantId(targetItem.id, cart);
    if (addonVariantId) {
      cart.items.forEach(function (i) {
        if (String(i.id) !== addonVariantId) return;
        var ip = normalizeProps(i.properties);
        if (ip[PROP_ROLE] === ROLE_MAIN) return;
        if (ip[PROP_MAIN_VARIANT] && String(ip[PROP_MAIN_VARIANT]) !== String(targetItem.id)) return;
        if (ip[PROP_ID] && bundleId && ip[PROP_ID] !== bundleId) return;
        var main = ip[PROP_ID] ? findBundleMain(cart, ip[PROP_ID]) : null;
        if (main && main.key !== targetKey) return;
        pushUnique(i);
      });
    }

    cart.items.forEach(function (i) {
      var ip = normalizeProps(i.properties);
      if (ip[PROP_MAIN_VARIANT] && String(ip[PROP_MAIN_VARIANT]) === String(targetItem.id)) {
        pushUnique(i);
      }
    });

    getLinkedAddonKeysFromDom(targetKey).forEach(function (addonKey) {
      var item = cart.items.find(function (i) { return i.key === addonKey; });
      if (item) pushUnique(item);
    });

    return linked;
  }

  function isOrphanAddon(cart, addonItem) {
    var props = normalizeProps(addonItem.properties);
    var isAddon = props[PROP_ROLE] === ROLE_ADDON || !!props[PROP_MAIN_VARIANT];
    if (!isAddon) return false;

    var bundleId = props[PROP_ID];
    var mainVariantId = props[PROP_MAIN_VARIANT];

    if (bundleId) {
      if (findBundleMain(cart, bundleId)) return false;
      return true;
    }

    if (mainVariantId) {
      var hasLinkedMain = cart.items.some(function (ci) {
        if (ci.key === addonItem.key) return false;
        if (String(ci.id) !== String(mainVariantId)) return false;
        var cp = normalizeProps(ci.properties);
        return cp[PROP_ROLE] !== ROLE_ADDON;
      });
      return !hasLinkedMain;
    }

    return false;
  }

  function findOrphanAddons(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (item) {
      return isOrphanAddon(cart, item);
    });
  }

  async function cleanupOrphanAddons(fetchFn, cart) {
    fetchFn = fetchFn || originalFetch.bind(window);

    if (!cart) {
      var cartRes = await fetchFn('/cart.js', { credentials: 'same-origin' });
      if (!cartRes.ok) return { cart: null, removedCount: 0 };
      cart = await cartRes.json();
    }

    var orphans = findOrphanAddons(cart);
    if (!orphans.length) return { cart: cart, removedCount: 0 };

    for (var i = 0; i < orphans.length; i++) {
      await postChange(fetchFn, orphans[i].key, 0);
    }

    var finalRes = await fetchFn('/cart.js', { credentials: 'same-origin' });
    var finalCart = finalRes.ok ? await finalRes.json() : cart;
    return { cart: finalCart, removedCount: orphans.length };
  }

  function expandLineItem(item, cart) {
    if (!item || item.id == null) return [item];

    var props = normalizeProps(item.properties);
    if (props[PROP_ROLE]) return [item];

    var addonId = getAddonVariantId(item.id, cart);
    if (!addonId) return [item];

    var bundleId = resolveBundleId(cart, item.id, addonId);
    var qty = item.quantity || 1;
    var mainProps = Object.assign({}, props);
    mainProps[PROP_ID] = bundleId;
    mainProps[PROP_ROLE] = ROLE_MAIN;
    mainProps[PROP_ADDON_VARIANT] = String(addonId);

    var addonProps = {};
    addonProps[PROP_ID] = bundleId;
    addonProps[PROP_ROLE] = ROLE_ADDON;
    addonProps[PROP_MAIN_VARIANT] = String(item.id);

    persistPair(item.id, addonId, bundleId);

    return [
      Object.assign({}, item, { quantity: qty, properties: mainProps }),
      { id: parseInt(addonId, 10), quantity: qty, properties: addonProps }
    ];
  }

  function expandAddPayload(bodyObj, cart) {
    collectBundleMap();
    if (cart) buildBundleMapFromCart(cart);
    if (bodyObj.items && Array.isArray(bodyObj.items)) {
      var expanded = [];
      bodyObj.items.forEach(function (item) {
        expanded = expanded.concat(expandLineItem(item, cart));
      });
      return { items: expanded };
    }
    if (bodyObj.id != null) {
      var lines = expandLineItem(bodyObj, cart);
      if (lines.length === 1) return lines[0];
      return { items: lines };
    }
    return bodyObj;
  }

  async function handleCartAdd(url, init, fetchFn) {
    if (!init || !init.body || typeof init.body !== 'string') {
      return fetchFn(url, init);
    }

    try {
      var parsed = JSON.parse(init.body);
      if (isAlreadyExpanded(parsed)) {
        return fetchFn(url, init);
      }

      var cart = null;
      try {
        var cartRes = await fetchFn('/cart.js', { credentials: 'same-origin' });
        if (cartRes.ok) cart = await cartRes.json();
      } catch (e) {}

      var expanded = expandAddPayload(parsed, cart);
      init = Object.assign({}, init, { body: JSON.stringify(expanded) });
    } catch (e) {}

    return fetchFn(url, init).then(function (res) {
      if (!res.ok) return res;
      return cleanupOrphanAddons(fetchFn).then(function () {
        return res;
      });
    });
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function isCartChangeUrl(url) {
    return /\/cart\/change(\.js)?(\?|$)/.test(url);
  }

  async function postChange(fetchFn, lineKey, quantity) {
    var res = await fetchFn('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
    if (!res.ok) {
      var err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || 'Cart update failed');
    }
    return res.json();
  }

  async function changeLine(lineKey, quantity, fetchFn) {
    fetchFn = fetchFn || originalFetch.bind(window);

    var cartRes = await fetchFn('/cart.js', { credentials: 'same-origin' });
    if (!cartRes.ok) throw new Error('Cart fetch failed');
    var cart = await cartRes.json();
    buildBundleMapFromCart(cart);

    if (isAddonLine(cart, lineKey)) {
      var blocked = cart.items.find(function (i) { return i.key === lineKey; });
      return blocked || cart;
    }

    var target = cart.items.find(function (i) {
      return i.key === lineKey || String(i.id) === String(lineKey);
    });
    if (!target) throw new Error('Cart line not found');

    var linkedAddons = findLinkedAddons(cart, target);
    var keys = [target.key];
    linkedAddons.forEach(function (addon) {
      if (keys.indexOf(addon.key) === -1) keys.push(addon.key);
    });

    var lastItem = null;
    for (var i = 0; i < keys.length; i++) {
      lastItem = await postChange(fetchFn, keys[i], quantity);
    }

    await cleanupOrphanAddons(fetchFn);
    return lastItem;
  }

  async function handleCartChange(url, init, fetchFn) {
    if (!init || !init.body) return fetchFn(url, init);

    var body;
    try {
      body = JSON.parse(init.body);
    } catch (e) {
      return fetchFn(url, init);
    }

    if (body.id == null || body.quantity == null) return fetchFn(url, init);

    try {
      var result = await changeLine(body.id, body.quantity, fetchFn);
      return new Response(JSON.stringify(result), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (e) {
      return fetchFn(url, init);
    }
  }

  originalFetch = window.fetch;
  window.fetch = function (input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
    var method = (init.method || 'GET').toUpperCase();

    if (method === 'POST' && isCartAddUrl(url) && init.body && typeof init.body === 'string') {
      return handleCartAdd(url, init, originalFetch.bind(window));
    }

    if (method === 'POST' && isCartChangeUrl(url)) {
      return handleCartChange(url, init, originalFetch.bind(window));
    }

    return originalFetch.call(window, input, init);
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cd-rec-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer-rec' } }));
      })
      .catch(function () {})
      .finally(function () {
        btn.disabled = false;
      });
  });

  var orphanCleanupPending = false;
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.source === 'bundle-cleanup') return;
    if (orphanCleanupPending) return;
    orphanCleanupPending = true;
    cleanupOrphanAddons(originalFetch.bind(window))
      .then(function (result) {
        orphanCleanupPending = false;
        if (result.removedCount > 0) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'bundle-cleanup' } }));
        }
      })
      .catch(function () {
        orphanCleanupPending = false;
      });
  });

  window.MtBundleCart = {
    collectBundleMap: collectBundleMap,
    buildBundleMapFromCart: buildBundleMapFromCart,
    expandAddPayload: expandAddPayload,
    getAddonVariantId: getAddonVariantId,
    findBundleMain: findBundleMain,
    findExistingBundleId: findExistingBundleId,
    findLinkedAddons: findLinkedAddons,
    findOrphanAddons: findOrphanAddons,
    cleanupOrphanAddons: function (cart) {
      return cleanupOrphanAddons(originalFetch.bind(window), cart || null);
    },
    changeLine: function (lineKey, quantity) {
      return changeLine(lineKey, quantity, originalFetch.bind(window));
    },
    normalizeProps: normalizeProps,
    PROP_ID: PROP_ID,
    PROP_ROLE: PROP_ROLE,
    PROP_ADDON_VARIANT: PROP_ADDON_VARIANT,
    PROP_MAIN_VARIANT: PROP_MAIN_VARIANT,
    ROLE_MAIN: ROLE_MAIN,
    ROLE_ADDON: ROLE_ADDON
  };
})();
